import firebaseConfig from "../layouts/prod.firebase.config";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  apiDomain: "https://pgcadd.stringconsultants.com/api/",
  firebaseCDN: firebaseConfig,
  NODE_ENV: "Dev_Ops_pgcadd",
};
